
export const loadImage = (url) => {
	const promise = new Promise(resolve => {
		const image = new Image(); // Using optional size for image
		image.src = url;
		image.onload = () => resolve(image);
	})
	return promise;
}
